import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function loadAdobeLaunch(profile: string, key: string): void {
  const adobeLaunchUrl = `//assets.adobedtm.com/ba7cd524c0f9/${profile}/launch-${key}.min.js`;
  const isFound = !!document.head.querySelector(
    `script[src="${adobeLaunchUrl}"]`
  );

  if (!isFound) {
    const adobeScriptElement = document.createElement('script');
    adobeScriptElement.async = true;
    adobeScriptElement.type = 'text/javascript';
    adobeScriptElement.src = adobeLaunchUrl;
    document.head.appendChild(adobeScriptElement);
  }
}

if (environment.adobeConfig?.length) {
  environment.adobeConfig.forEach((adobe) => {
    loadAdobeLaunch(adobe.profile, adobe.key);
  });
}

function loadAuraAppBar(): void {
  const auraAppBarUrl = environment.auraAppBarUrl;

  const isFound = !!document.head.querySelector(
    `script[src="${auraAppBarUrl}"]`
  );

  if (!isFound) {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'module';
    scriptElement.src = auraAppBarUrl;
    document.head.appendChild(scriptElement);
  }
}

if (!document.URL.includes('/manifests/access-code')) {
  loadAuraAppBar();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
